module.exports = __webpack_public_path__ + "static/media/aaiAnimated.aeed419e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/aaiAnimated.gif
// module id = 154
// module chunks = 0